import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { InputLabelLinkConfig } from '../models/input-label-link-config.model';

@Component({
  template: ''
})
export class InputBaseComponent {
  @Input() public inputControl: UntypedFormControl;
  @Input() public labelTranslateKey = '';
  @Input() public displayLabel = true;
  @Input() public placeholderTranslateKey: string | null;
  @Input() public labelLinkConfig?: InputLabelLinkConfig | null = null;

  public isInputControlInvalid(): boolean {
    return this.inputControl.errors && (this.inputControl.dirty || this.inputControl.touched);
  }

  public isInputControlRequired(): boolean {
    if (!this.inputControl) {
      throw new Error('inputControl is not defined');
    }

    if (this.inputControl.validator) {
      const validator = this.inputControl.validator({} as AbstractControl);

      return !!(validator && validator.required);
    }

    return false;
  }
}
